(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aqu-reviews-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  function buildStars(n) {
    n = Math.max(0, Math.min(5, Math.round(n || 5)));
    return '★'.repeat(n) + '☆'.repeat(5 - n);
  }

  // Hide the native judge.me carousel ONLY once our carousel has real reviews,
  // so a fetch failure falls back to judge.me's own reviews (never zero reviews).
  // judge.me lazy-renders its carousel on scroll, so retry until it appears.
  function hideNative(section, base, attempts) {
    if (!section) return;
    attempts = attempts || 0;
    var sib = section.nextElementSibling, hops = 0;
    while (sib && hops < 5) {
      if (sib.querySelector && sib.querySelector('.jdgm-carousel, .jdgm-widget, [data-jdgm-id], [id^="jdgm"]')) {
        sib.classList.add(base + '-jdgm-mhide');
        return;
      }
      sib = sib.nextElementSibling; hops++;
    }
    if (attempts < 16) { setTimeout(function () { hideNative(section, base, attempts + 1); }, 500); }
  }

  function init(scope) {
    var wrap = (scope || document).querySelector('[data-aqrb-carousel]');
    if (!wrap) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var track = wrap.querySelector('[data-aqrb-track]');
    if (!track || track.getAttribute('data-loaded')) return;
    track.setAttribute('data-loaded', '1');

    var base = wrap.getAttribute('data-base') || 'aqrb';
    var section = wrap.closest('.shopify-section');
    var shop = wrap.getAttribute('data-shop');
    var origin = wrap.getAttribute('data-origin') || window.location.origin;
    var accent = wrap.getAttribute('data-accent') || '#d2815f';
    var starColor = wrap.getAttribute('data-star-color') || accent;
    var max = parseInt(wrap.getAttribute('data-max') || '8', 10);

    // Scroll-progress hint (matches the other mobile sliders' affordance).
    var bar = wrap.querySelector('[data-aqrb-bar]');
    function updateBar() {
      if (!bar) return;
      var mx = track.scrollWidth - track.clientWidth;
      var p = mx > 0 ? Math.min(1, Math.max(0, track.scrollLeft / mx)) : 0;
      bar.style.width = (20 + p * 80) + '%';
    }
    track.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();

    // Keyboard/single-pointer alternative to swiping (WCAG 2.1.1 / 2.5.7).
    function step(dir) {
      var slide = track.querySelector('article');
      var w = slide ? slide.getBoundingClientRect().width + 14 : track.clientWidth * 0.85;
      // Use instant scroll: mandatory scroll-snap reliably fights programmatic smooth scrolling.
      track.scrollBy({ left: dir * w, behavior: 'auto' });
    }
    var prevBtn = wrap.querySelector('[data-aqrb-prev]');
    var nextBtn = wrap.querySelector('[data-aqrb-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

    if (!shop) return;

    var endpoint = 'https://cdn.judge.me/reviews/reviews_for_carousel'
      + '?reviews_selection=product_reviews&carousel_type=cards&star_rating=all'
      + '&max_reviews=' + encodeURIComponent(max)
      + '&url=' + encodeURIComponent(origin)
      + '&shop_domain=' + encodeURIComponent(shop)
      + '&platform=shopify&primary_language=en&display_order=most_recent';

    fetch(endpoint).then(function (r) {
      if (!r.ok) throw new Error('bad status');
      return r.json();
    }).then(function (data) {
      var reviews = (data && (data.reviews || data.data || data.results)) || [];
      if (!Array.isArray(reviews) || !reviews.length) throw new Error('no reviews');

      var added = 0;
      reviews.slice(0, max).forEach(function (rev) {
        var rating = (rev.rating != null) ? rev.rating : (rev.score != null ? rev.score : 5);
        var text = (rev.body || rev.review || rev.content || rev.title || '').toString().trim();
        if (!text) return;
        var name = rev.reviewer_name || rev.reviewer || rev.name || 'Verified buyer';
        var product = rev.product_title || rev.product || '';

        var card = document.createElement('article');
        card.className = base + '__slide ' + base + '__rev';

        var stars = document.createElement('div');
        stars.className = base + '__rev-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = buildStars(rating);
        stars.style.color = starColor;

        var body = document.createElement('p');
        body.className = base + '__rev-body';
        if (text.length > 150) text = text.slice(0, 150).replace(/\s+\S*$/, '') + '…';
        body.textContent = '“' + text + '”';

        var who = document.createElement('p');
        who.className = base + '__rev-who';
        who.textContent = name;

        card.appendChild(stars);
        card.appendChild(body);
        card.appendChild(who);

        if (product) {
          var prod = document.createElement('p');
          prod.className = base + '__rev-prod';
          prod.textContent = product;
          card.appendChild(prod);
        }
        track.appendChild(card);
        added++;
      });

      // Only now — with real reviews on screen — replace the native carousel.
      if (added > 0) hideNative(section, base);
      updateBar();
    }).catch(function () {
      // Keep the intro card AND leave judge.me's native carousel visible as the fallback.
    });
  }

  if (document.readyState !== 'loading') { init(document); }
  else { document.addEventListener('DOMContentLoaded', function () { init(document); }); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target || document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-logos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setup(scope) {
    (scope || document).querySelectorAll('[data-marquee-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var section = btn.closest('[data-section-type="logos"]');
      if (!section) return;
      btn.addEventListener('click', function () {
        var paused = section.classList.toggle('is-marquee-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.setAttribute('aria-label', paused ? 'Play logo animation' : 'Pause logo animation');
      });
    });
  }
  if (document.readyState !== 'loading') { setup(document); }
  else { document.addEventListener('DOMContentLoaded', function () { setup(document); }); }
  document.addEventListener('shopify:section:load', function (e) { setup(e.target || document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initVideo(section) {
    var video = section.querySelector('[data-video-autoplay]') || section.querySelector('video');
    var btn = section.querySelector('[data-video-toggle]');
    if (!video || !btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';

    function setPaused(paused) {
      btn.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', String(!paused));
      btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
    }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) { try { video.pause(); } catch (e) {} setPaused(true); }

    btn.addEventListener('click', function () {
      if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); setPaused(false); }
      else { video.pause(); setPaused(true); }
    });
  }

  function initAll() {
    document.querySelectorAll('.section-video').forEach(initVideo);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target || document;
    var section = root.querySelector ? root.querySelector('.section-video') : null;
    if (section) initVideo(section); else initAll();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
